import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type CompatErrorCode =
  | 'COMPAT_SIZE_TOO_SMALL'
  | 'COMPAT_DESCRIPTOR_MISMATCH'
  | 'COMPAT_VISUAL_TYPE_UNSUPPORTED'
  | 'COMPAT_NO_DATA_SOURCE'
  | 'COMPAT_UNKNOWN';

export interface CompatibilityWarningItem {
  widgetId: string;
  type: CompatErrorCode;
  reason: string;
  suggestion: string;
}

export interface CompatibilityFix {
  targetCols?: number;
  targetRows?: number;
  descriptorKey?: string;
}

export interface CompatibilityState {
  warnings: CompatibilityWarningItem[];
  fixes: Record<string, CompatibilityFix>;
}

const initialState: CompatibilityState = {
  warnings: [],
  fixes: {},
};

const compatibilitySlice = createSlice({
  name: 'compatibility',
  initialState,
  reducers: {
    setWarnings(state, action: PayloadAction<CompatibilityWarningItem[]>) {
      state.warnings = action.payload;
    },
    setFix(state, action: PayloadAction<{ widgetId: string; fix: CompatibilityFix }>) {
      state.fixes[action.payload.widgetId] = action.payload.fix;
    },
    clearFix(state, action: PayloadAction<string>) {
      delete state.fixes[action.payload];
    },
    clearCompatibilityState() {
      return initialState;
    },
  },
});

export const { setWarnings, setFix, clearFix, clearCompatibilityState } = compatibilitySlice.actions;

export default compatibilitySlice.reducer;
